import React from 'react';
import { Icon, Tooltip } from 'antd';

const Columns = (onDelete) => {
  return [
    {
      title: '',
      key: 'action',
      width: '10%',
      align: 'center',
      render: (text, record) => <Tooltip title="Xóa dòng này"><Icon className='gx-text-danger' onClick={() => onDelete(record.key)} type="delete" /></Tooltip>,
    },
    {
      title: 'Campaign',
      dataIndex: 'campaign',
      editable: true,
      width: '25%',
    },
    {
      title: 'Industry',
      dataIndex: 'industry',
      editable: true,
      width: '25%',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      editable: true,
      width: '25%',
    },
    {
      title: 'Month Buzz Volume',
      dataIndex: 'value',
      editable: true,
      width: '25%',
    },
  ];
};

export default Columns;
